import Component, { debounce, subscribe } from "../../js/lib/component";
import Scroll from "../../js/lib/scroll";
import Page from "../page/page";
import anime from "animejs";

const classList = {
  root: ".js-header",
  trigger: ".js-header-trigger",
  sidemenu: ".js-header-sidemenu",
};

export default class Header extends Component {
  events() {
    this.$.trigger.on("click", () => this.toggleMenu());
    this.$.document.on("click", (e) => this.closeMenu(e));
    subscribe("page:esc", () => this.closeMenu());
    subscribe(
      "page:resize",
      debounce(() => this.closeMenu(), 600)
    );
  }
  toggleMenu() {
    this[this.get("opened") ? "closeMenu" : "openMenu"].call(this);
  }
  closeMenu(e) {
    if (!this.get("opened")) return;

    if (e) {
      const $target = $(e.target);

      const isSidemenu = $target.is(classList.sidemenu);
      const inSidemenu = $target.closest(classList.sidemenu).length > 0;
      const isTrigger = $target.is(classList.trigger);
      const inTrigger = $target.closest(classList.trigger).length > 0;

      if (isSidemenu || inSidemenu || isTrigger || inTrigger) return;
    }

    const submenu = this.$.sidemenu.get(0);

    this.$.root.removeClass("has-opened-sidemenu");

    anime({
      targets: submenu,
      translateX: "100%",
      duration: 450,
      easing: "easeOutCubic",
      complete: () => {
        this.set({ opened: false });
        this.$.sidemenu.removeAttr("style");
        Page.bodyOverflowDisable();
      },
    });
  }
  openMenu() {
    if (this.get("opened")) return;

    const submenu = this.$.sidemenu.get(0);

    anime.set(submenu, {
      display: "block",
      translateX: "100%",
    });

    this.$.root.addClass("has-opened-sidemenu");
    Scroll.to(this.$.page);

    anime({
      targets: submenu,
      translateX: 0,
      duration: 450,
      easing: "easeOutCubic",
      complete: () => {
        this.set({ opened: true });
        Page.bodyOverflowEnable();
      },
    });
  }
}

Component.mount(Header, {
  name: "Header",
  classList,
  state: {
    opened: false,
  },
});
